import { render, staticRenderFns } from "./GoodsRecommend.vue?vue&type=template&id=6c35c242&scoped=true&"
import script from "./GoodsRecommend.vue?vue&type=script&lang=js&"
export * from "./GoodsRecommend.vue?vue&type=script&lang=js&"
import style0 from "./GoodsRecommend.vue?vue&type=style&index=0&id=6c35c242&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c35c242",
  null
  
)

export default component.exports